const state = {
  alertText:'',
}

const mutations = {
  // 是否是收藏
  setAlertText (state, data) {
    state.alertText = data;
    setTimeout(() => {
      state.alertText = '';
    }, 1500);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}